import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonWithDropDown from '@lib/components/ButtonWithDropDown/ButtonWithDropDown';
import { ButtonTypes } from '@lib/components/Button/Button';
import { NavItem, NavItemTypeEnum } from '@lib/components/Menu/Menu';
import Icons from '@lib/components/Icons/Icons';
import downloadHandler from '@lib/utils/downloadHandler';
import { materialSymbolsOutlined } from '@lib/enums/common';
import styles from './DownloadTemplateButton.module.scss';

const { VITE_CDN_URL } = import.meta.env;

export default function DownloadTemplateButton({
  isSitesAvailable,
  isAssetsAvailable,
}: {
  isSitesAvailable: boolean;
  isAssetsAvailable: boolean;
}) {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const navItems: NavItem<object>[] = [
    {
      id: 'sites',
      title: t('sites'),
      type: NavItemTypeEnum.PrimaryText,
      leftIcon: Icons.homePin,
      onClick: () =>
        downloadHandler(
          `${VITE_CDN_URL}/templates/${i18n.language}/import/Site-import-template.xlsx`,
        ),
      predictorFnVisible: () => isSitesAvailable,
    },
    {
      id: 'areas',
      title: t('areas'),
      type: NavItemTypeEnum.PrimaryText,
      leftIcon: Icons.locationOn,
      onClick: () =>
        downloadHandler(
          `${VITE_CDN_URL}/templates/${i18n.language}/import/Areas-import-template.xlsx`,
        ),
      predictorFnVisible: () => isSitesAvailable,
    },
    {
      id: 'assets',
      title: t('assets'),
      type: NavItemTypeEnum.PrimaryText,
      leftIcon: Icons.inventory,
      onClick: () =>
        downloadHandler(
          `${VITE_CDN_URL}/templates/${i18n.language}/import/Equipment-import-template.xlsx`,
        ),
      predictorFnVisible: () => isAssetsAvailable,
    },
  ];
  return (
    <ButtonWithDropDown
      buttonProps={{
        buttonText: t('download-template'),
        buttonType: ButtonTypes.primaryOutlined,
        className: styles.btnWrap,
        leftIcon: 'download',
        leftIconClassName: materialSymbolsOutlined,
      }}
      navItems={navItems}
      popoverProps={{
        width: 190,
      }}
    />
  );
}
